import Markdown, { type Components } from 'react-markdown';

import { Button } from '@flintmint/web-shared/components/button';

import { agreements } from '../agreements';

import styles from './agreement-view.module.scss';

export const AgreementView = (props: { agreement: (typeof agreements)[keyof typeof agreements]; onBack?: () => void }) => {
  const { agreement, onBack } = props;

  return (
    <>
      <div className={styles.agreementHeading}>
        <h1 tabIndex={-1} data-view-heading>
          {agreement.title}
        </h1>
        <p className={styles.effective}>{agreement.effective}</p>
      </div>
      <div className={styles.agreementText}>
        <Markdown skipHtml components={markdownComponents}>
          {withoutTitleLine(agreement.text)}
        </Markdown>
      </div>
      {onBack && (
        <Button size="big" onClick={onBack}>
          Back to agreements
        </Button>
      )}
    </>
  );
};

// The view shows its own title above the panel, so the document's leading title line is dropped.
const withoutTitleLine = (text: string) => text.replace(/^\uFEFF?\s*# .*\n+/, '');

const markdownComponents: Components = {
  // Links to other sites open in a new tab so the gated tab never navigates away from the agreements;
  // mail, phone, in-page and relative links keep the browser's own handling.
  a: ({ href, title, children }) => {
    const external = /^(https?:)?\/\//i.test(href ?? '');
    return (
      <a href={href} title={title} target={external ? '_blank' : undefined} rel={external ? 'noreferrer' : undefined}>
        {children}
      </a>
    );
  },
};
